import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const PoolDegenSection = () => {
  const navigate = useNavigate(); // Initialize useNavigate

  return (
    <div className="w-full bg-gradient-to-br from-purple-900 via-indigo-900 to-violet-900 rounded-lg p-8 mb-12 shadow-xl overflow-hidden">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-8">
        {/* Left side with content */}
        <div className="flex-1 space-y-6 z-10">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-white/10 border border-purple-400/30 rounded-full flex items-center justify-center shadow-inner">
              {/* AI/Brain Icon */}
              <svg xmlns="http://www.w3.org/2000/svg" className="w-7 h-7 text-purple-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9.5 13a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/>
                <path d="M14.5 13a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/>
                <path d="M11.5 16h1"/>
                <path d="M17.5 11c0 2.485-2.015 4.5-4.5 4.5S8.5 13.485 8.5 11"/>
                <path d="M17.5 11a5.5 5.5 0 0 0-11 0"/>
                <path d="M17.5 11c0-1.57.672-3.01 1.757-4.025A5.48 5.48 0 0 0 12 5.5a5.48 5.48 0 0 0-7.257 1.475C5.828 7.99 6.5 9.43 6.5 11"/>
                <path d="M12 5.5V5"/>
                <path d="M12 4.5a2.5 2.5 0 0 1-2.334-4"/>
                <path d="M12 4.5a2.5 2.5 0 0 0 2.334-4"/>
              </svg>
            </div>
            <h2 className="text-3xl font-bold text-white">BitPool AI Agent Quests</h2>
          </div>
          <p className="text-lg text-gray-300">
            Engage with our AI Agent, complete challenging quests, and earn exclusive BAI rewards. Test your skills and knowledge!
          </p>
          <div className="flex items-center gap-4">
            {/* Removed the Telegram specific button */}
            <button
              onClick={() => navigate('/quests')} // Navigate to the quests page
              className="px-6 py-3 bg-gradient-to-r from-purple-500 to-indigo-500 hover:from-purple-600 hover:to-indigo-600 text-white font-bold rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-purple-500/50 flex items-center gap-2"
            >
              View Quests
              {/* Arrow Icon */}
              <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </button>
          </div>
        </div>
        
        {/* Right side with AI-themed visual */}
        <div className="relative w-full md:w-96 h-64 z-0">
          {/* Background Glows */}
          <div className="absolute inset-0 opacity-70">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-40 h-40 bg-purple-600/30 rounded-full blur-2xl animate-pulse"></div>
            <div className="absolute top-1/4 right-1/4 w-32 h-32 bg-indigo-600/30 rounded-full blur-2xl animate-pulse delay-500"></div>
            <div className="absolute bottom-1/4 left-1/4 w-24 h-24 bg-violet-600/30 rounded-full blur-2xl animate-pulse delay-1000"></div>
          </div>
          {/* Central AI Icon */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="relative w-40 h-40">
              {/* Pulsing Rings */}
              <div className="absolute inset-0 border-2 border-purple-400/30 rounded-full animate-ping opacity-50"></div>
              <div className="absolute inset-2 border-2 border-indigo-400/30 rounded-full animate-ping delay-300 opacity-50"></div>
              
              {/* Main Icon Container */}
              <div className="relative w-full h-full bg-gradient-to-br from-purple-700/20 via-indigo-700/20 to-violet-700/20 border border-purple-400/40 rounded-full flex items-center justify-center backdrop-blur-sm shadow-inner">
                {/* Larger AI/Brain Icon */}
                <svg xmlns="http://www.w3.org/2000/svg" className="w-16 h-16 text-purple-200 opacity-80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9.5 13a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/>
                  <path d="M14.5 13a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/>
                  <path d="M11.5 16h1"/>
                  <path d="M17.5 11c0 2.485-2.015 4.5-4.5 4.5S8.5 13.485 8.5 11"/>
                  <path d="M17.5 11a5.5 5.5 0 0 0-11 0"/>
                  <path d="M17.5 11c0-1.57.672-3.01 1.757-4.025A5.48 5.48 0 0 0 12 5.5a5.48 5.48 0 0 0-7.257 1.475C5.828 7.99 6.5 9.43 6.5 11"/>
                  <path d="M12 5.5V5"/>
                  <path d="M12 4.5a2.5 2.5 0 0 1-2.334-4"/>
                  <path d="M12 4.5a2.5 2.5 0 0 0 2.334-4"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoolDegenSection;
